import React from 'react';

const BoxMessageInfo = ({ children, renderStatement } = props) => {
	if(renderStatement)
		return (
			<div className='box-message-info'>
				{ children }
			</div>
		);
	
	return null
};

export default BoxMessageInfo;